
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]/help-and-support",
      function () {
        return require("private-next-pages/[insuranceType]/help-and-support/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insuranceType]/help-and-support"])
      });
    }
  